<template>
  <div id="app" class="mt-5 container">
    <div class="card-form">
      <div class="card-form__inner">
        <ul
          class="list-group"
          style="margin-top: 20px; background-color: lightgray"
        >
          <li class="list-group-item">
            <div class="d-flex justify-content-start">
              <div>
                <b>Summer Athletes </b>
                <span
                  class="badge actionFeature"
                  style="margin-left: 7px; font-size: 15px"
                >
                  {{ subscriptionName }}
                </span>
              </div>
            </div>
            <div></div>
          </li>
          <li class="list-group-item">
            <div class="d-flex justify-content-between">
              <div>Billing Period - {{ this.period }}ly</div>
            </div>
          </li>
          <li
            class="list-group-item"
            v-if="
              this.isExternal &&
              this.trialApplied &&
              this.period === 'Month' &&
              !this.recruitReferralExists
            "
          >
            <div class="d-flex justify-content-between">
              <div>
                Today's Total:
                <div
                  class="text-small text-muted fst-italic"
                  style="font-size: 12px"
                >
                  Trial ends in 7 days
                </div>
              </div>
              <div>
                <s
                  ><i> ${{ getPrice }}</i></s
                >
                $0.00
              </div>
            </div>
          </li>
          <li class="list-group-item" v-else-if="!recruitReferralExists">
            <div class="d-flex justify-content-between">
              <div>Today's Total:</div>
              <div v-if="this.period === 'Month'">${{ getPrice }}</div>
              <div v-else>
                <s
                  ><i>${{ getPotentialYearlyPrice }}</i></s
                >
                ${{ getPrice }}
              </div>
            </div>
          </li>
          <li class="list-group-item" v-else>
            <div class="d-flex justify-content-between">
              <div>
                Today's Total: <br /><label
                  class="fst-italic text-muted"
                  style="font-size: 12px"
                  >Pay ${{ getSubsequentMonthReferralPrice }} after first
                  month</label
                >
              </div>
              <div v-if="this.period === 'Month'">
                <span style="margin-right: 5px"
                  ><s class="fst-italic">${{ getPrice }}</s></span
                >
                ${{ getFirstMonthReferralPrice }}
              </div>
            </div>
          </li>
        </ul>
        <div v-if="this.period !== 'Month'" class="text-end">
          <label class="fst-italic text-muted"
            >Saving {{ getSavingPercentage }}% Annually</label
          >
        </div>
        <br />

        <PayPalSubscription
          :planID="this.planID"
          :initialActivity="this.initialActivity"
          v-if="!this.recruitReferralExists"
        ></PayPalSubscription>

        <div>
          <button
            class="card-form__button rounded-pill"
            @click="submitPayment"
            :disabled="cardInfoIncomplete"
            :style="{
              backgroundColor: cardInfoIncomplete ? 'lightgray' : '',
              transition: cardInfoIncomplete ? 'none' : 'all 1s ease',
              cursor: cardInfoIncomplete ? 'not-allowed' : 'pointer',
            }"
          >
            Purchase
          </button>
          <br />
          <h5 class="text-center text-muted mt-3"><i>Cancel at anytime</i></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import swal2 from "sweetalert2";
import PayPalSubscription from "./PayPalSubscription.vue";
export default {
  components: { PayPalSubscription },
  props: {
    isMobile: Boolean,
    subscriptionName: String,
    period: String,
    price: Number,
    monthlyPrice: Number,
    billingInfo: Object,
    isExternal: Boolean,
    trialApplied: Boolean,
    recruitReferral: Object,
    planID: String,
    initialActivity: Object,
  },
  data() {
    return {};
  },
  methods: {
    back() {
      this.$emit("back");
    },
    submitPayment() {
      this.$emit("proceed");
    },

    changeBillingPeriod() {
      if (this.period !== "Month") {
        swal2
          .fire({
            title: "Are you sure?",
            text: "You will lose out on up to 30% savings by paying monthly.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, change it!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$emit("changeBillingPeriod");
            }
          });
      } else {
        this.$emit("changeBillingPeriod");
      }
    },
  },
  created() {},
  computed: {
    getPrice() {
      return numeral(this.price).format("0,0.00");
    },

    getPotentialPriceFees() {
      return numeral(this.price * 0.07).format("0,0.00");
    },

    getPotentialYearlyPrice() {
      return numeral(this.monthlyPrice * 12).format("0,0.00");
    },

    getSavingPercentage() {
      return Math.floor(100 - (this.price / (this.monthlyPrice * 12)) * 100);
    },

    cardInfoIncomplete() {
      if (this.billingInfo.cardNumber == "") {
        return true;
      }
      if (this.billingInfo.cardMonth == "") {
        return true;
      }
      if (this.billingInfo.cardYear == "") {
        return true;
      }
      if (this.billingInfo.cardCvv == "") {
        return true;
      }
      if (this.billingInfo.cardFirstName == "") {
        return true;
      }
      if (this.billingInfo.cardLastName == "") {
        return true;
      }
      if (this.billingInfo.zipCode == "") {
        return true;
      }

      return false;
    },

    recruitReferralExists() {
      if (this.recruitReferral) {
        if (this.recruitReferral.referralCode) {
          return true;
        }
      }
      return false;
    },
    getFirstMonthReferralPrice() {
      return numeral(this.recruitReferral.firstMonthPrice).format("0,0.00");
    },

    getSubsequentMonthReferralPrice() {
      return numeral(this.recruitReferral.recurringMonthlyPrice).format(
        "0,0.00"
      );
    },
  },
};
</script>
<style scoped>
img.rounded-corners {
  border-radius: 10px;
}
.actionFeature {
  background-color: #a39ed0;
}

.link {
  color: #0d6efd;
  text-decoration: underline;
}

.link:hover {
  opacity: 0.8;
}
</style>
